import React from 'react'

import { string } from 'prop-types'

function ItemContext({ thumbnail, modelName, subLabel }) {
  return (
    <div className="order-summary__source-item">
      <img
        className="order-summary__source-item-thumb"
        src={thumbnail}
        alt={modelName}
        loading="lazy"
      />
      <div className="order-summary__source-item-text">
        <span className="order-summary__source-item-name cgt-body-base-semibold">{modelName}</span>
        <span className="order-summary__source-item-sublabel cgt-caption">{subLabel}</span>
      </div>
    </div>
  )
}

ItemContext.propTypes = {
  thumbnail: string.isRequired,
  modelName: string.isRequired,
  subLabel: string.isRequired,
}

export default ItemContext
